import { KEY } from '../../types';
import * as types from './types';

export const GET_INSURANCE_SUBSCRIPTION = `${KEY}.GET_INSURANCE_SUBSCRIPTION`;
export const GET_INSURANCE_SUBSCRIPTION_SUCCESS = `${KEY}.GET_INSURANCE_SUBSCRIPTION_SUCCESS`;
export const GET_INSURANCE_SUBSCRIPTION_FAIL = `${KEY}.GET_INSURANCE_SUBSCRIPTION_FAIL`;

export const getInsuranceSubscription = () => ({
  type: GET_INSURANCE_SUBSCRIPTION,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'getInsuranceSubscription'
    }
  }
});

export const UPDATE_INSURANCE_SUBSCRIPTION = `${KEY}.UPDATE_INSURANCE_SUBSCRIPTION`;
export const UPDATE_INSURANCE_SUBSCRIPTION_SUCCESS = `${KEY}.UPDATE_INSURANCE_SUBSCRIPTION_SUCCESS`;
export const UPDATE_INSURANCE_SUBSCRIPTION_FAIL = `${KEY}.UPDATE_INSURANCE_SUBSCRIPTION_FAIL`;

export const updateInsuranceSubscription = (payload: types.UpdateInsuranceSubscriptionPayload) => ({
  type: UPDATE_INSURANCE_SUBSCRIPTION,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'updateInsuranceSubscription',
      data: payload
    }
  }
});

export const REMOVE_INSURANCE_SUBSCRIPTION = `${KEY}.REMOVE_INSURANCE_SUBSCRIPTION`;
export const REMOVE_INSURANCE_SUBSCRIPTION_SUCCESS = `${KEY}.REMOVE_INSURANCE_SUBSCRIPTION_SUCCESS`;
export const REMOVE_INSURANCE_SUBSCRIPTION_FAIL = `${KEY}.REMOVE_INSURANCE_SUBSCRIPTION_FAIL`;

export const removeInsuranceSubscription = () => ({
  type: REMOVE_INSURANCE_SUBSCRIPTION,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'removeInsuranceSubscription'
    }
  }
});

export const SET_INSURANCE_STATUS = `${KEY}.SET_INSURANCE_STATUS`;

export const setInsuranceStatus = (status: string | null) => ({
  type: SET_INSURANCE_STATUS,
  payload: status
});
